export const MIN_DURATION_MS = 1500
export const MIN_PROGRESS_UPDATE_DURATION_MS = 700
export const MAX_PROGRESS_BEFORE_RESPONSE = 95
export const MIN_PROGRESS_UPDATE_INTERVAL = 50
export const MIN_PROGRESS_INCREMENT = 1
